export default __webpack_public_path__ + "static/media/check.4f96b78b.svg";